import React, { ReactElement, useState } from "react";
import styles from "./styles.module.scss"
import { Translate } from "react-redux-i18n";

import { Box, Button, Drawer } from "@mui/material";
import DrawerContent from "../DrawerContent";

export default function AppFooter(): ReactElement {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false)
  return (
    <Box>
      {
        !openDrawer &&
        <Box className={styles.appFooterContainer}>
          <Button onClick={() => setOpenDrawer(true)} className={styles.openDrawerButton}>
            <Translate value="content.openFooter" />
          </Button>
        </Box>
      }
      <Drawer
        anchor="bottom"
        sx={{ maxWidth: "50px" }}
        open={openDrawer}
        hideBackdrop={true}
        elevation={32}
        onClose={() => setOpenDrawer(false)}
        className={styles.drawer}
      >
        <Box className={styles.content}>
          {openDrawer &&
            <Box className={styles.closeButtonContainer}>
              <Button onClick={() => setOpenDrawer(false)} className={styles.closeButton}>
                <Translate value="content.closeFooter" />
              </Button>
            </Box>
          }
          <DrawerContent />
        </Box>
      </Drawer>

    </Box>
  )
}